// Central configuration for all URLs
export const config = {
  // API Base URL
  get API_BASE() {
    // Always prefer the environment variable if set
    if (import.meta.env.VITE_API_URL) {
      return import.meta.env.VITE_API_URL;
    }
    
    // In production, use the production API URL
    const isProduction = window.location.hostname !== 'localhost';
    if (isProduction) {
      // For beyondpages.io, use api.beyondpages.io
      if (window.location.hostname.includes('beyondpages.io')) {
        return 'https://api.beyondpages.io';
      }
      // For other production environments, use relative URLs
      return '';
    }
    
    // In development, default to localhost
    return 'http://localhost:3002';
  },
  
  // QR Domain (where QR codes point to)
  get QR_DOMAIN() {
    // Always prefer the environment variable if set
    if (import.meta.env.VITE_QR_DOMAIN) {
      return import.meta.env.VITE_QR_DOMAIN;
    }
    
    // In production, QR codes should point to the API
    const isProduction = window.location.hostname !== 'localhost';
    if (isProduction) {
      if (window.location.hostname.includes('beyondpages.io')) {
        return 'https://api.beyondpages.io';
      }
      return window.location.origin;
    }
    
    // In development, point to backend
    return 'http://localhost:3002';
  }
};

// Export as default for easier imports
export default config; 